import { Pipe, PipeTransform } from '@angular/core'
import * as moment from 'moment';


@Pipe({
  name: 'timeFromNow'
})
export class TimeFromNow implements PipeTransform {
  
  
  transform(value: Date) : string {

    if (!value) {
      return '';
    }
    
    let date = moment(value).fromNow();

    return date.charAt(0).toUpperCase() + date.slice(1);
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/pipes/timefromnow.ts